import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetOurDoctorMessage,
	GetOurDoctorMessageParams,
	GetOurDoctorMessageModel,
} from 'domain/usecases/private/home/get-our-doctor-message';

export class RemoteGetOurDoctorMessage implements GetOurDoctorMessage {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetOurDoctorMessageModel>,
	) {}

	async get({signal, ...params}: GetOurDoctorMessageParams): Promise<GetOurDoctorMessageModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			case HttpStatusCode.forbidden:
				throw new APIError(httpResponse.status, httpResponse.data);
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
